export default __webpack_public_path__ + "static/media/backcover.23b8ff44.txt";